import { useQuery, keepPreviousData } from '@tanstack/react-query';
import {
  fetchMySegmentCorrections,
  fetchPendingSegmentCorrections,
  fetchReviewedSegmentCorrections,
  type ReviewedSegmentCorrectionsParams,
} from '../api/segmentCorrectionApi';
import { correctionKeys } from './correctionKeys';

// query key namespacing: ['corrections','segment', <scope>, ...args] —
// 생성·승인·반려 mutation 이 `segment` scope 를 선언하면 이 세 키가 함께 걸린다
// (`./correctionKeys.ts`). 시각 정정과 루트는 공유하되 하위 네임스페이스가 달라,
// 한쪽 mutation 이 다른 쪽 화면을 지우지 않는다 — 별도 테이블이라 지울 이유도 없다.

export function useMySegmentCorrections() {
  return useQuery({
    queryKey: correctionKeys.segmentMy(),
    queryFn: fetchMySegmentCorrections,
  });
}

export function usePendingSegmentCorrections(enabled = true) {
  return useQuery({
    queryKey: correctionKeys.segmentPending(),
    queryFn: fetchPendingSegmentCorrections,
    staleTime: 30_000,
    placeholderData: keepPreviousData,
    enabled,
  });
}

export function useReviewedSegmentCorrections(
  params: ReviewedSegmentCorrectionsParams,
  enabled = true
) {
  return useQuery({
    queryKey: correctionKeys.segmentReviewed(params),
    queryFn: () => fetchReviewedSegmentCorrections(params),
    staleTime: 30_000,
    placeholderData: keepPreviousData,
    enabled,
  });
}
